import { SURVEY_ID } from './surveyID'

export const SURVEY_TYPES = {
  [SURVEY_ID.SLOW_NO_GROWTH]: {
    name: 'Slow/No Growth',
    // pageID: '1111',
  },
  [SURVEY_ID.GROWING_RURAL]: {
    name: 'Growing Rural',
    // pageID: '2222',
  },
  [SURVEY_ID.URBAN]: {
    name: 'Urban',
    // pageID: '3333',
  },
}

export const ZIP_CODES = [
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84301',
   name: 'BEAR RIVER CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84302',
   name: 'BRIGHAM CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84304',
   name: 'CACHE JUNCTION',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84305',
   name: 'CLARKSTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84306',
   name: 'COLLINSTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84307',
   name: 'CORINNE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84308',
   name: 'CORNISH',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84309',
   name: 'DEWEYVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84311',
   name: 'FIELDING',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 17,
   county_name: 'Rich',
   zip_code: '84028',
   name: 'GARDEN CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84312',
   name: 'GARLAND',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84313',
   name: 'GROUSE CREEK',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84314',
   name: 'HONEYVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84316',
   name: 'HOWELL',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84318',
   name: 'HYDE PARK',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84319',
   name: 'HYRUM',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'BearRiver',
 },
 {
   county_number: 17,
   county_name: 'Rich',
   zip_code: '84038',
   name: 'LAKETOWN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84320',
   name: 'LEWISTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84321',
   name: 'LOGAN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84322',
   name: 'LOGAN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84323',
   name: 'LOGAN',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '83342',
   name: 'MALTA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84324',
   name: 'MANTUA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84325',
   name: 'MENDON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84326',
   name: 'MILLVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84327',
   name: 'NEWTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84341',
   name: 'NORTH LOGAN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84328',
   name: 'PARADISE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84329',
   name: 'PARK VALLEY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84330',
   name: 'PLYMOUTH',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84331',
   name: 'PORTAGE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84332',
   name: 'PROVIDENCE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'BearRiver',
 },
 {
   county_number: 17,
   county_name: 'Rich',
   zip_code: '84064',
   name: 'RANDOLPH',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84333',
   name: 'RICHMOND',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84334',
   name: 'RIVERSIDE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84335',
   name: 'SMITHFIELD',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84336',
   name: 'SNOWVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84337',
   name: 'TREMONTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84338',
   name: 'TRENTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 3,
   county_name: 'Cache',
   zip_code: '84339',
   name: 'WELLSVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'BearRiver',
 },
 {
   county_number: 2,
   county_name: 'Box Elder',
   zip_code: '84340',
   name: 'WILLARD',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'BearRiver',
 },
 {
   county_number: 17,
   county_name: 'Rich',
   zip_code: '84086',
   name: 'WOODRUFF',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'BearRiver',
 },
 {
   county_number: 13,
   county_name: 'Kane',
   zip_code: '84710',
   name: 'ALTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 9,
   county_name: 'Garfield',
   zip_code: '84712',
   name: 'ANTIMONY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 1,
   county_name: 'Beaver',
   zip_code: '84713',
   name: 'BEAVER',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 11,
   county_name: 'Iron',
   zip_code: '84714',
   name: 'BERYL',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 9,
   county_name: 'Garfield',
   zip_code: '84716',
   name: 'BOULDER',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 11,
   county_name: 'Iron',
   zip_code: '84719',
   name: 'BRIAN HEAD',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 9,
   county_name: 'Garfield',
   zip_code: '84764',
   name: 'BRYCE CANYON CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 9,
   county_name: 'Garfield',
   zip_code: '84718',
   name: 'CANNONVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 11,
   county_name: 'Iron',
   zip_code: '84720',
   name: 'CEDAR CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 11,
   county_name: 'Iron',
   zip_code: '84721',
   name: 'CEDAR CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84722',
   name: 'CENTRAL',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84783',
   name: 'DAMMERON VALLEY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 13,
   county_name: 'Kane',
   zip_code: '84762',
   name: 'DUCK CREEK VILLAGE CPU',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84725',
   name: 'ENTERPRISE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 9,
   county_name: 'Garfield',
   zip_code: '84726',
   name: 'ESCALANTE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 13,
   county_name: 'Kane',
   zip_code: '84729',
   name: 'GLENDALE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 1,
   county_name: 'Beaver',
   zip_code: '84731',
   name: 'GREENVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84733',
   name: 'GUNLOCK',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 9,
   county_name: 'Garfield',
   zip_code: '84735',
   name: 'HATCH',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 9,
   county_name: 'Garfield',
   zip_code: '84736',
   name: 'HENRIEVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84784',
   name: 'HILDALE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84737',
   name: 'HURRICANE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84738',
   name: 'IVINS',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 13,
   county_name: 'Kane',
   zip_code: '84741',
   name: 'KANAB',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 11,
   county_name: 'Iron',
   zip_code: '84742',
   name: 'KANARRAVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84745',
   name: 'LA VERKIN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84746',
   name: 'LEEDS',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 1,
   county_name: 'Beaver',
   zip_code: '84751',
   name: 'MILFORD',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 1,
   county_name: 'Beaver',
   zip_code: '84752',
   name: 'MINERSVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 11,
   county_name: 'Iron',
   zip_code: '84753',
   name: 'MODENA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 13,
   county_name: 'Kane',
   zip_code: '84755',
   name: 'MOUNT CARMEL',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84757',
   name: 'NEW HARMONY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 11,
   county_name: 'Iron',
   zip_code: '84756',
   name: 'NEWCASTLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 13,
   county_name: 'Kane',
   zip_code: '84758',
   name: 'ORDERVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 9,
   county_name: 'Garfield',
   zip_code: '84759',
   name: 'PANGUITCH',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 11,
   county_name: 'Iron',
   zip_code: '84760',
   name: 'PARAGONAH',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 11,
   county_name: 'Iron',
   zip_code: '84761',
   name: 'PAROWAN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84781',
   name: 'PINE VALLEY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84763',
   name: 'ROCKVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84770',
   name: 'SAINT GEORGE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84771',
   name: 'SAINT GEORGE',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84790',
   name: 'SAINT GEORGE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84765',
   name: 'SANTA CLARA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84767',
   name: 'SPRINGDALE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84791',
   name: 'ST. GEORGE',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 11,
   county_name: 'Iron',
   zip_code: '84772',
   name: 'SUMMIT',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84774',
   name: 'TOQUERVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 9,
   county_name: 'Garfield',
   zip_code: '84776',
   name: 'TROPIC',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84782',
   name: 'VEYO',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84779',
   name: 'VIRGIN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 27,
   county_name: 'Washington',
   zip_code: '84780',
   name: 'WASHINGTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'FiveCounty',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84004',
   name: 'ALPINE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84003',
   name: 'AMERICAN FORK',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 22,
   county_name: 'Summit',
   zip_code: '82930',
   name: 'BEAR RIVER - SUMMIT',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84013',
   name: 'CEDAR VALLEY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 22,
   county_name: 'Summit',
   zip_code: '84017',
   name: 'COALVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84005',
   name: 'EAGLE MOUNTAIN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 22,
   county_name: 'Summit',
   zip_code: '84024',
   name: 'ECHO',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84626',
   name: 'ELBERTA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84633',
   name: 'GOSHEN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'MAG',
 },
 {
   county_number: 26,
   county_name: 'Wasatch',
   zip_code: '84032',
   name: 'HEBER CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'MAG',
 },
 {
   county_number: 22,
   county_name: 'Summit',
   zip_code: '84033',
   name: 'HENEFER',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'MAG',
 },
 {
   county_number: 22,
   county_name: 'Summit',
   zip_code: '84036',
   name: 'KAMAS',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84043',
   name: 'LEHI',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84042',
   name: 'LINDON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84664',
   name: 'MAPLETON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 26,
   county_name: 'Wasatch',
   zip_code: '84049',
   name: 'MIDWAY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'MAG',
 },
 {
   county_number: 22,
   county_name: 'Summit',
   zip_code: '84055',
   name: 'OAKLEY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84057',
   name: 'OREM',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84058',
   name: 'OREM',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84097',
   name: 'OREM',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 22,
   county_name: 'Summit',
   zip_code: '84060',
   name: 'PARK CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 22,
   county_name: 'Summit',
   zip_code: '84068',
   name: 'PARK CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 22,
   county_name: 'Summit',
   zip_code: '84098',
   name: 'PARK CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84651',
   name: 'PAYSON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 22,
   county_name: 'Summit',
   zip_code: '84061',
   name: 'PEOA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84062',
   name: 'PLEASANT GROVE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84601',
   name: 'PROVO',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84602',
   name: 'PROVO',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84604',
   name: 'PROVO',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84606',
   name: 'PROVO',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84653',
   name: 'SALEM',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84655',
   name: 'SANTAQUIN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84045',
   name: 'SARATOGA SPRINGS',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84660',
   name: 'SPANISH FORK',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84663',
   name: 'SPRINGVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 25,
   county_name: 'Utah',
   zip_code: '84059',
   name: 'VINEYARD',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'MAG',
 },
 {
   county_number: 26,
   county_name: 'Wasatch',
   zip_code: '84082',
   name: 'WALLSBURG',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'MAG',
 },
 {
   county_number: 19,
   county_name: 'San Juan',
   zip_code: '84510',
   name: 'ANETH',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SEUtah',
 },
 {
   county_number: 19,
   county_name: 'San Juan',
   zip_code: '84511',
   name: 'BLANDING',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SEUtah',
 },
 {
   county_number: 19,
   county_name: 'San Juan',
   zip_code: '84512',
   name: 'BLUFF',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SEUtah',
 },
 {
   county_number: 8,
   county_name: 'Emery',
   zip_code: '84513',
   name: 'CASTLE DALE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SEUtah',
 },
 {
   county_number: 10,
   county_name: 'Grand',
   zip_code: '84515',
   name: 'CISCO',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SEUtah',
 },
 {
   county_number: 8,
   county_name: 'Emery',
   zip_code: '84516',
   name: 'CLAWSON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SEUtah',
 },
 {
   county_number: 8,
   county_name: 'Emery',
   zip_code: '84518',
   name: 'CLEVELAND',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SEUtah',
 },
 {
   county_number: 4,
   county_name: 'Carbon',
   zip_code: '84520',
   name: 'EAST CARBON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SEUtah',
 },
 {
   county_number: 8,
   county_name: 'Emery',
   zip_code: '84521',
   name: 'ELMO',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SEUtah',
 },
 {
   county_number: 8,
   county_name: 'Emery',
   zip_code: '84522',
   name: 'EMERY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SEUtah',
 },
 {
   county_number: 8,
   county_name: 'Emery',
   zip_code: '84523',
   name: 'FERRON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SEUtah',
 },
 {
   county_number: 8,
   county_name: 'Emery',
   zip_code: '84525',
   name: 'GREEN RIVER',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SEUtah',
 },
 {
   county_number: 4,
   county_name: 'Carbon',
   zip_code: '84526',
   name: 'HELPER',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SEUtah',
 },
 {
   county_number: 19,
   county_name: 'San Juan',
   zip_code: '84533',
   name: 'HITE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SEUtah',
 },
 {
   county_number: 8,
   county_name: 'Emery',
   zip_code: '84528',
   name: 'HUNTINGTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SEUtah',
 },
 {
   county_number: 4,
   county_name: 'Carbon',
   zip_code: '84529',
   name: 'KENILWORTH',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SEUtah',
 },
 {
   county_number: 19,
   county_name: 'San Juan',
   zip_code: '84530',
   name: 'LA SAL',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SEUtah',
 },
 {
   county_number: 19,
   county_name: 'San Juan',
   zip_code: '84531',
   name: 'MEXICAN HAT',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SEUtah',
 },
 {
   county_number: 10,
   county_name: 'Grand',
   zip_code: '84532',
   name: 'MOAB',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SEUtah',
 },
 {
   county_number: 19,
   county_name: 'San Juan',
   zip_code: '84534',
   name: 'MONTEZUMA CREEK',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SEUtah',
 },
 {
   county_number: 19,
   county_name: 'San Juan',
   zip_code: '84535',
   name: 'MONTICELLO',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SEUtah',
 },
 {
   county_number: 19,
   county_name: 'San Juan',
   zip_code: '84536',
   name: 'MONUMENT VALLEY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SEUtah',
 },
 {
   county_number: 8,
   county_name: 'Emery',
   zip_code: '84537',
   name: 'ORANGEVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SEUtah',
 },
 {
   county_number: 4,
   county_name: 'Carbon',
   zip_code: '84501',
   name: 'PRICE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SEUtah',
 },
 {
   county_number: 4,
   county_name: 'Carbon',
   zip_code: '84539',
   name: 'SUNNYSIDE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SEUtah',
 },
 {
   county_number: 10,
   county_name: 'Grand',
   zip_code: '84540',
   name: 'THOMPSON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SEUtah',
 },
 {
   county_number: 4,
   county_name: 'Carbon',
   zip_code: '84542',
   name: 'WELLINGTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SEUtah',
 },
 {
   county_number: 21,
   county_name: 'Sevier',
   zip_code: '84711',
   name: 'ANNABELLA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 21,
   county_name: 'Sevier',
   zip_code: '84620',
   name: 'AURORA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 20,
   county_name: 'Sanpete',
   zip_code: '84621',
   name: 'AXTELL',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 28,
   county_name: 'Wayne',
   zip_code: '84715',
   name: 'BICKNELL',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 20,
   county_name: 'Sanpete',
   zip_code: '84622',
   name: 'CENTERFIELD',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 20,
   county_name: 'Sanpete',
   zip_code: '84623',
   name: 'CHESTER',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 16,
   county_name: 'Piute',
   zip_code: '84723',
   name: 'CIRCLEVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 14,
   county_name: 'Millard',
   zip_code: '84624',
   name: 'DELTA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 21,
   county_name: 'Sevier',
   zip_code: '84724',
   name: 'ELSINORE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 20,
   county_name: 'Sanpete',
   zip_code: '84627',
   name: 'EPHRAIM',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 12,
   county_name: 'Juab',
   zip_code: '84628',
   name: 'EUREKA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 20,
   county_name: 'Sanpete',
   zip_code: '84629',
   name: 'FAIRVIEW',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 20,
   county_name: 'Sanpete',
   zip_code: '84630',
   name: 'FAYETTE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 14,
   county_name: 'Millard',
   zip_code: '84631',
   name: 'FILLMORE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 20,
   county_name: 'Sanpete',
   zip_code: '84632',
   name: 'FOUNTAIN GREEN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 14,
   county_name: 'Millard',
   zip_code: '84728',
   name: 'GARRISON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 21,
   county_name: 'Sevier',
   zip_code: '84730',
   name: 'GLENWOOD',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 16,
   county_name: 'Piute',
   zip_code: '84732',
   name: 'GREENWICH',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 20,
   county_name: 'Sanpete',
   zip_code: '84634',
   name: 'GUNNISON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 28,
   county_name: 'Wayne',
   zip_code: '84734',
   name: 'HANKSVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 14,
   county_name: 'Millard',
   zip_code: '84635',
   name: 'HINCKLEY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 14,
   county_name: 'Millard',
   zip_code: '84636',
   name: 'HOLDEN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 21,
   county_name: 'Sevier',
   zip_code: '84739',
   name: 'JOSEPH',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 16,
   county_name: 'Piute',
   zip_code: '84740',
   name: 'JUNCTION',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 14,
   county_name: 'Millard',
   zip_code: '84637',
   name: 'KANOSH',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 16,
   county_name: 'Piute',
   zip_code: '84743',
   name: 'KINGSTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 21,
   county_name: 'Sevier',
   zip_code: '84744',
   name: 'KOOSHAREM',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 14,
   county_name: 'Millard',
   zip_code: '84638',
   name: 'LEAMINGTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 12,
   county_name: 'Juab',
   zip_code: '84639',
   name: 'LEVAN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 28,
   county_name: 'Wayne',
   zip_code: '84747',
   name: 'LOA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 28,
   county_name: 'Wayne',
   zip_code: '84749',
   name: 'LYMAN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 14,
   county_name: 'Millard',
   zip_code: '84640',
   name: 'LYNNDYL',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 20,
   county_name: 'Sanpete',
   zip_code: '84642',
   name: 'MANTI',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 16,
   county_name: 'Piute',
   zip_code: '84750',
   name: 'MARYSVALE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 20,
   county_name: 'Sanpete',
   zip_code: '84643',
   name: 'MAYFIELD',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 14,
   county_name: 'Millard',
   zip_code: '84644',
   name: 'MEADOW',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 12,
   county_name: 'Juab',
   zip_code: '84645',
   name: 'MONA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 21,
   county_name: 'Sevier',
   zip_code: '84754',
   name: 'MONROE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 20,
   county_name: 'Sanpete',
   zip_code: '84646',
   name: 'MORONI',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 20,
   county_name: 'Sanpete',
   zip_code: '84647',
   name: 'MOUNT PLEASANT',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 12,
   county_name: 'Juab',
   zip_code: '84648',
   name: 'NEPHI',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 14,
   county_name: 'Millard',
   zip_code: '84649',
   name: 'OAK CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 21,
   county_name: 'Sevier',
   zip_code: '84652',
   name: 'REDMOND',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 21,
   county_name: 'Sevier',
   zip_code: '84701',
   name: 'RICHFIELD',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 21,
   county_name: 'Sevier',
   zip_code: '84654',
   name: 'SALINA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 14,
   county_name: 'Millard',
   zip_code: '84656',
   name: 'SCIPIO',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 21,
   county_name: 'Sevier',
   zip_code: '84766',
   name: 'SEVIER',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 21,
   county_name: 'Sevier',
   zip_code: '84657',
   name: 'SIGURD',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 20,
   county_name: 'Sanpete',
   zip_code: '84662',
   name: 'SPRING CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 20,
   county_name: 'Sanpete',
   zip_code: '84665',
   name: 'STERLING',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 28,
   county_name: 'Wayne',
   zip_code: '84773',
   name: 'TEASDALE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 28,
   county_name: 'Wayne',
   zip_code: '84775',
   name: 'TORREY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'SixCounty',
 },
 {
   county_number: 20,
   county_name: 'Sanpete',
   zip_code: '84667',
   name: 'WALES',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'SixCounty',
 },
 {
   county_number: 7,
   county_name: 'Duchesne',
   zip_code: '84001',
   name: 'ALTAMONT',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 7,
   county_name: 'Duchesne',
   zip_code: '84002',
   name: 'ALTONAH',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 7,
   county_name: 'Duchesne',
   zip_code: '84007',
   name: 'BLUEBELL',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 24,
   county_name: 'Uintah',
   zip_code: '84008',
   name: 'BONANZA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 7,
   county_name: 'Duchesne',
   zip_code: '84021',
   name: 'DUCHESNE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 5,
   county_name: 'Daggett',
   zip_code: '84023',
   name: 'DUTCH JOHN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 24,
   county_name: 'Uintah',
   zip_code: '84026',
   name: 'FORT DUCHESNE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 7,
   county_name: 'Duchesne',
   zip_code: '84027',
   name: 'FRUITLAND',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 7,
   county_name: 'Duchesne',
   zip_code: '84031',
   name: 'HANNA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 24,
   county_name: 'Uintah',
   zip_code: '84035',
   name: 'JENSEN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 24,
   county_name: 'Uintah',
   zip_code: '84039',
   name: 'LAPOINT',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 5,
   county_name: 'Daggett',
   zip_code: '84046',
   name: 'MANILA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 7,
   county_name: 'Duchesne',
   zip_code: '84051',
   name: 'MOUNTAIN HOME',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 7,
   county_name: 'Duchesne',
   zip_code: '84052',
   name: 'MYTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 7,
   county_name: 'Duchesne',
   zip_code: '84053',
   name: 'NEOLA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 24,
   county_name: 'Uintah',
   zip_code: '84063',
   name: 'RANDLETT',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 7,
   county_name: 'Duchesne',
   zip_code: '84066',
   name: 'ROOSEVELT',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 7,
   county_name: 'Duchesne',
   zip_code: '84072',
   name: 'TABIONA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 7,
   county_name: 'Duchesne',
   zip_code: '84073',
   name: 'TALMAGE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 24,
   county_name: 'Uintah',
   zip_code: '84076',
   name: 'TRIDELL',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 24,
   county_name: 'Uintah',
   zip_code: '84078',
   name: 'VERNAL',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 24,
   county_name: 'Uintah',
   zip_code: '84079',
   name: 'VERNAL',
   type: 'Point',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 24,
   county_name: 'Uintah',
   zip_code: '84085',
   name: 'WHITEROCKS',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'UintahBasin',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84006',
   name: 'BINGHAM CANYON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 6,
   county_name: 'Davis',
   zip_code: '84010',
   name: 'BOUNTIFUL',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 6,
   county_name: 'Davis',
   zip_code: '84011',
   name: 'BOUNTIFUL',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 6,
   county_name: 'Davis',
   zip_code: '84014',
   name: 'CENTERVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 6,
   county_name: 'Davis',
   zip_code: '84015',
   name: 'CLEARFIELD',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 6,
   county_name: 'Davis',
   zip_code: '84016',
   name: 'CLEARFIELD',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 6,
   county_name: 'Davis',
   zip_code: '84089',
   name: 'CLEARFIELD',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 15,
   county_name: 'Morgan',
   zip_code: '84018',
   name: 'CROYDON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84020',
   name: 'DRAPER',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 23,
   county_name: 'Tooele',
   zip_code: '84022',
   name: 'DUGWAY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84310',
   name: 'EDEN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'WFRC',
 },
 {
   county_number: 6,
   county_name: 'Davis',
   zip_code: '84025',
   name: 'FARMINGTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 23,
   county_name: 'Tooele',
   zip_code: '84029',
   name: 'GRANTSVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84096',
   name: 'HERRIMAN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 6,
   county_name: 'Davis',
   zip_code: '84056',
   name: 'HILL AFB',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84315',
   name: 'HOOPER',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84317',
   name: 'HUNTSVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'WFRC',
 },
 {
   county_number: 23,
   county_name: 'Tooele',
   zip_code: '84034',
   name: 'IBAPAH',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'WFRC',
 },
 {
   county_number: 6,
   county_name: 'Davis',
   zip_code: '84037',
   name: 'KAYSVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 6,
   county_name: 'Davis',
   zip_code: '84040',
   name: 'LAYTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 6,
   county_name: 'Davis',
   zip_code: '84041',
   name: 'LAYTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84044',
   name: 'MAGNA',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84047',
   name: 'MIDVALE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 15,
   county_name: 'Morgan',
   zip_code: '84050',
   name: 'MORGAN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84107',
   name: 'MURRAY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84157',
   name: 'MURRAY (SLC)',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 6,
   county_name: 'Davis',
   zip_code: '84054',
   name: 'NORTH SALT LAKE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84407',
   name: 'ODGEN',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84201',
   name: 'OGDEN',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84244',
   name: 'OGDEN',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84401',
   name: 'OGDEN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84401',
   name: 'OGDEN',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84401',
   name: 'OGDEN',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84402',
   name: 'OGDEN',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84403',
   name: 'OGDEN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84404',
   name: 'OGDEN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84405',
   name: 'OGDEN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84408',
   name: 'OGDEN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84408',
   name: 'OGDEN',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84409',
   name: 'OGDEN',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84412',
   name: 'OGDEN',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84414',
   name: 'OGDEN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84415',
   name: 'OGDEN',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84065',
   name: 'RIVERTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 29,
   county_name: 'Weber',
   zip_code: '84067',
   name: 'ROY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 23,
   county_name: 'Tooele',
   zip_code: '84069',
   name: 'RUSH VALLEY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84138',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84101',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84101',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84102',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84103',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84104',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84105',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84106',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84108',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84109',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84110',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84111',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84111',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84111',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84112',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84113',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84114',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84114',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84115',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84116',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84117',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84119',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84121',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84122',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84123',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84124',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84125',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84126',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84127',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84129',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84130',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84131',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84132',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84133',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84134',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84135',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84136',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84137',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84139',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84140',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84141',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84142',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84143',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84144',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84145',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84147',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84148',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84149',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84150',
   name: 'SALT LAKE CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84150',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84152',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84152',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84153',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84158',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84171',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84180',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84184',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84189',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84190',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84199',
   name: 'SALT LAKE CITY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84070',
   name: 'SANDY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84090',
   name: 'SANDY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84091',
   name: 'SANDY',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84092',
   name: 'SANDY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84093',
   name: 'SANDY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84094',
   name: 'SANDY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84009',
   name: 'SOUTH JORDAN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84095',
   name: 'SOUTH JORDAN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84165',
   name: 'SOUTH SL (SLC)',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 23,
   county_name: 'Tooele',
   zip_code: '84071',
   name: 'STOCKTON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'WFRC',
 },
 {
   county_number: 6,
   county_name: 'Davis',
   zip_code: '84075',
   name: 'SYRACUSE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84129',
   name: 'TAYLORSVILLE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 23,
   county_name: 'Tooele',
   zip_code: '84074',
   name: 'TOOELE',
   type: 'Zone',
   suggested_survey: SURVEY_ID.GROWING_RURAL,
   aog_area: 'WFRC',
 },
 {
   county_number: 23,
   county_name: 'Tooele',
   zip_code: '84080',
   name: 'VERNON',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'WFRC',
 },
 {
   county_number: 23,
   county_name: 'Tooele',
   zip_code: '84083',
   name: 'WENDOVER',
   type: 'Zone',
   suggested_survey: SURVEY_ID.SLOW_NO_GROWTH,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84081',
   name: 'WEST JORDAN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84084',
   name: 'WEST JORDAN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84088',
   name: 'WEST JORDAN',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84170',
   name: 'WEST VALLEY (SLC)',
   type: 'Point',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84118',
   name: 'WEST VALLEY CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84120',
   name: 'WEST VALLEY CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 18,
   county_name: 'Salt Lake',
   zip_code: '84128',
   name: 'WEST VALLEY CITY',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 },
 {
   county_number: 6,
   county_name: 'Davis',
   zip_code: '84087',
   name: 'WOODS CROSS',
   type: 'Zone',
   suggested_survey: SURVEY_ID.URBAN,
   aog_area: 'WFRC',
 }
]